import insertEntity from '../../utils/insertEntity';
import EntityTypes from '../../../types/EntityTypes';
export default function onInputEmoji(event, editor, next) {
  event.preventDefault();
  event.stopPropagation();
  return insertEntity(editor, null, event.data, EntityTypes.EMOJI, {});
}